export const mapperShiftDemandsFromBackend = (item: any) => {
  return {
    id: item.id,
    name: item.name,
    startDate: item.startDate,
    endDate: item.endDate,
    status: item.status,
  };
};

export const mapperShiftDemandsToBackend = (values: any) => {
  return {
    shift_template_id: values.shiftTemplateId?.value || values.shiftTemplateId,
    position_id: values.positionId?.value || values.positionId,
    date: values.date,
    required_employees: Number(values.requiredEmployees),
  };
};
